import React from "react";

const TOKEN_RE = /(\*\*[^*\n]+?\*\*|\*[^*\n]+?\*|`[^`\n]+?`)/g;

export function renderInlineMarkdown(text: string): React.ReactNode {
	if (!text) return text;
	const out: React.ReactNode[] = [];
	let lastIndex = 0;
	let key = 0;
	let m: RegExpExecArray | null;
	TOKEN_RE.lastIndex = 0;
	while ((m = TOKEN_RE.exec(text)) !== null) {
		if (m.index > lastIndex) {
			out.push(text.slice(lastIndex, m.index));
		}
		const token = m[0];
		if (token.startsWith("**")) {
			out.push(<strong key={key++}>{token.slice(2, -2)}</strong>);
		} else if (token.startsWith("`")) {
			out.push(<code key={key++}>{token.slice(1, -1)}</code>);
		} else {
			out.push(<em key={key++}>{token.slice(1, -1)}</em>);
		}
		lastIndex = m.index + token.length;
	}
	if (lastIndex < text.length) {
		out.push(text.slice(lastIndex));
	}
	return out.length === 1 ? out[0] : out;
}
